import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { clsx as i } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import e from "./roche-quote.module.scss.js";
import { RocheUIQuoteLayout as a, RocheUIQuoteSize as l } from "./roche-quote.types.js";
const g = ({
  quote: h,
  size: m = l.BIG,
  layout: n = a.NORMAL,
  isEqualRatio: u = !1,
  image: _,
  sublines: t,
  link: s
}) => {
  const c = n === a.WITH_IMAGE, d = m === l.SMALL, q = i(e["roche-quote"], {
    [e["roche-quote--with-image"]]: c,
    [e["roche-quote--equal-ratio"]]: u
  }), f = i(e["roche-quote__text"], {
    [e["roche-quote__text--small"]]: d
  });
  return /* @__PURE__ */ r("figure", { className: q, children: [
    c && /* @__PURE__ */ o("div", { className: e["roche-quote__image"], children: _ }),
    /* @__PURE__ */ r("div", { className: e["roche-quote__content"], children: [
      /* @__PURE__ */ o("blockquote", { children: /* @__PURE__ */ o("p", { className: f, children: h }) }),
      /* @__PURE__ */ r("figcaption", { children: [
        t && t.length > 0 && /* @__PURE__ */ o("div", { className: e["roche-quote__subline"], children: t }),
        c && s && /* @__PURE__ */ o("div", { className: e["roche-quote__link"], children: s })
      ] })
    ] })
  ] });
};
export {
  g as RocheUIQuote
};
